module.exports = __webpack_public_path__ + "img/blob-g.648d95a1.svg";